import {createStyles} from '@material-ui/core';

export const style = createStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
});
